import { render, staticRenderFns } from "./ManageBookingsCatalog.vue?vue&type=template&id=3cf10937"
import script from "./ManageBookingsCatalog.vue?vue&type=script&lang=js"
export * from "./ManageBookingsCatalog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports